import { AlertCircle } from "lucide-react";
import { useSubscription } from "~/context/SubscriptionContext";
import { useIsAgencyClient, useTeamAgency } from "~/hooks/useTeamAccess";
import { billingPath } from "~/lib/billing-paths";
import { isPastDueSubscription } from "~/lib/subscription-status";
import { Link, useLocation } from "~/lib/team-router";

export default function PastDueBanner() {
  const teamAgency = useTeamAgency();
  const isAgencyClient = useIsAgencyClient();
  const { subscription } = useSubscription();
  const location = useLocation();
  const isAgency = Boolean(teamAgency);

  if (!isPastDueSubscription(subscription)) {
    return null;
  }

  if (
    location.pathname.startsWith("/settings/workspace/billing") ||
    location.pathname.startsWith("/agency/settings/billing")
  ) {
    return null;
  }

  return (
    <div className="shrink-0 border-b border-red-200 bg-red-50 px-4 py-2">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-red-900">
        <AlertCircle className="h-4 w-4 shrink-0 text-red-700" />
        <p className="min-w-0 flex-1">
          {isAgencyClient
            ? "Payment failed for this workspace. Contact your agency to keep using it."
            : "Payment failed. Update your payment method to keep using this workspace."}
        </p>
        {!isAgencyClient && (
          <Link
            to={billingPath(isAgency)}
            className="shrink-0 font-medium text-red-800 underline underline-offset-2 hover:text-red-950"
          >
            Update payment
          </Link>
        )}
      </div>
    </div>
  );
}
